import { IconReceiptBill } from '@sequencehq/core-components'

import {
  InvoicePreviewCard,
  InvoicePreviewCardSkeleton,
  NodeTimeline,
  useNodeTimelineVariant,
  ViewInvoiceButton
} from 'Automations/components'
import { ExecutionSummaryComponent } from 'Automations/nodeDefinitions/types'
import { useInvoiceData } from 'Automations/watchtower/inbox/notifications/hooks/useInvoiceData'

export const InvoiceSentExecutionSummary: ExecutionSummaryComponent = ({
  automationExecution,
  isLatestNodeExecution
}) => {
  const showPreviews = useNodeTimelineVariant() === 'DEFAULT'
  const { invoice, customer, invoiceDetails, isPending } = useInvoiceData(
    automationExecution.input.invoiceId
  )

  // `isPending` stays true for disabled queries, so only treat it as loading
  // when there is actually an invoice to fetch — otherwise fall through to
  // rendering nothing, as before.
  const isLoadingInvoice =
    Boolean(automationExecution.input.invoiceId) && isPending

  return (
    <NodeTimeline.Item
      icon={<IconReceiptBill />}
      showStem={!isLatestNodeExecution}
    >
      <NodeTimeline.Title>
        <NodeTimeline.UserAction
          label="Invoice sent"
          timestamp={automationExecution.createTime}
        />
      </NodeTimeline.Title>
      {showPreviews &&
        (isLoadingInvoice ? (
          <InvoicePreviewCardSkeleton collapsed={!isLatestNodeExecution} />
        ) : (
          invoice &&
          customer &&
          invoiceDetails && (
            <InvoicePreviewCard
              invoice={invoice}
              customer={customer}
              invoiceDetails={invoiceDetails}
              startCollapsed={!isLatestNodeExecution}
              action={
                <ViewInvoiceButton
                  invoiceId={invoice.id}
                  fullWidth
                  data-testid="watchtower.invoiceSent.viewInvoice"
                />
              }
            />
          )
        ))}
    </NodeTimeline.Item>
  )
}
